var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgDragdrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.016,
    height: 41,
    viewBox: "0 0 56.016 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img-dragdrop",
    transform: "translate(-287.984 -929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2693",
    "data-name": "Rectangle 2693",
    transform: "translate(287.984 929)",
    fill: "none",
    stroke: "#72b3db",
    strokeWidth: 2,
    strokeDasharray: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 38.05,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43,
    height: 36.05,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2694",
    "data-name": "Rectangle 2694",
    width: 44,
    height: 33,
    rx: 5,
    transform: "translate(300 937)",
    fill: "#f6a07b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_11980669191537183377",
    "data-name": 11980669191537183000,
    d: "M16.879,13.714,12.137,8.97l3.459-2a.611.611,0,0,0-.079-1.1L.9.044A.611.611,0,0,0,.109.838L5.936,15.458a.611.611,0,0,0,1.1.079l2-3.46,4.741,4.743a.611.611,0,0,0,.865,0l2.242-2.243A.611.611,0,0,0,16.879,13.714Z",
    transform: "translate(319.936 948.025)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDragdrop);
export default __webpack_public_path__ + "static/media/img-dragdrop.6f73a9a3.svg";
export { ForwardRef as ReactComponent };